module.exports = __webpack_public_path__ + "static/Cortex-b193b4793b32a119073a0d7e3335e4e6.jpg";